import React, { FC, useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { connect } from "react-redux";
import { RootState } from "../../../store/reducers";
import { Album, Track } from "../../../models/track";
import {
  createAlbum,
  deleteAlbum,
  addTrackToAlbum,
} from "../../../store/actions/songs";

interface IAPros {
  albums?: Album[];
  uid: string;
  createAlbum: Function;
  selected: Track;
}

const AlbumModal: FC<IAPros> = ({ albums, uid, createAlbum, selected }) => {
  const [form, setForm] = useState(false);
  const [mounted, setMounted] = useState(true);
  const [mess, setMess] = useState("");
  const [album, setAlbum] = useState<Album>({
    title: "",
    cover: undefined,
    covername: "",
    tracks: [],
  });

  useEffect(() => {
    setMounted(true);
    return () => {
      setMounted(false);
    };
  }, []);

  return (
    <AnimatePresence>
      <div id="album-modal" className="uk-flex-top" data-uk-modal>
        <div className="uk-modal-dialog uk-margin-auto-vertical">
          <div className="uk-modal-header">
            <h2 className="uk-modal-title">Albums</h2>
          </div>

          <div
            className="uk-modal-body   uk-height-large"
            data-uk-overflow-auto
          >
            <h6 className="uk-modal-title">My Albums</h6>
            <ul className="uk-list">
              <AnimatePresence>
                {albums &&
                  albums.map((album) => {
                    let { title, id } = album;
                    return (
                      <motion.li
                        initial={{
                          x: 100,
                        }}
                        animate={{
                          x: 0,
                        }}
                        exit={{
                          x: `-100vw`,
                        }}
                        style={{
                          cursor: "pointer",
                          textTransform: "capitalize",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                        key={id}
                        onClick={() => {
                          console.log(id);
                          if (id) addTrackToAlbum(selected, id);
                        }}
                      >
                        <span>{title}</span>
                        <span>
                          <i
                            className="material-icons-outlined"
                            style={{ color: "red" }}
                            onClick={() => deleteAlbum(album)}
                          >
                            delete
                          </i>
                        </span>
                      </motion.li>
                    );
                  })}
              </AnimatePresence>
            </ul>
            <button
              className="uk-button"
              onClick={() => {
                if (mounted) setForm(!form);
              }}
            >
              {form ? "Hide form" : "Show form"}
            </button>

            <AnimatePresence>
              {form && (
                <motion.form
                  initial={{
                    y: 200,
                    scale: 0,
                  }}
                  animate={{
                    y: 0,
                    scale: 1,
                  }}
                  exit={{
                    x: "100vw",
                  }}
                  onSubmit={async (e) => {
                    console.log(mounted);
                    e.preventDefault();
                    if (!album.cover || !album.covername) {
                      if (mounted) {
                        setMess("Album cover is required");
                        setTimeout(() => setMess(""), 4000);
                      }
                    } else if (!album.title) {
                      if (mounted) {
                        setMess("Album title is required");
                        setTimeout(() => setMess(""), 4000);
                      }
                    } else {
                      album.uid = uid;

                      await createAlbum(album);
                      if (mounted)
                        setAlbum({
                          title: "",
                          cover: undefined,
                          covername: "",
                          tracks: [],
                        });
                    }
                  }}
                  //   className=" uk-form-small"
                >
                  <input
                    type="text"
                    placeholder="album title"
                    value={album.title}
                    className="uk-input uk-margin-small-top uk-form-width-large"
                    onChange={(e) => {
                      if (mounted)
                        setAlbum({
                          ...album,
                          title: e.currentTarget.value,
                        });
                    }}
                  />
                  <br />
                  <div className=" uk-margin-small-top">
                    Cover: {album.covername && album.covername}
                  </div>
                  <div className="js-upload" data-uk-form-custom>
                    <input
                      type="file"
                      onChange={(e) => {
                        if (mounted)
                          if (e.currentTarget.files)
                            setAlbum({
                              ...album,
                              cover: e.currentTarget.files[0],
                              covername: e.currentTarget.files[0].name,
                            });
                      }}
                    />
                    <button className="uk-button uk-button-primary  uk-margin-small-top">
                      <i className="material-icons uk-float-left">publish</i>{" "}
                      Upload
                    </button>
                  </div>
                  <br />
                  {mess && (
                    <div className="feedback uk-margin-medium">{mess}</div>
                  )}

                  <button className="uk-button uk-margin-small-top">
                    Create
                  </button>
                </motion.form>
              )}
            </AnimatePresence>
          </div>
        </div>
      </div>
    </AnimatePresence>
  );
};

const mapState = (state: RootState) => ({
  albums: state.data.albums,
  uid: state.auth.user.id,
  selected: state.songs.selected,
});

export default connect(mapState, { createAlbum })(AlbumModal);
